var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import * as Modal from 'react-modal';
import { fetchApi, generateRoute, translate, translateChoice } from '@js/common/helpers';
import { initAuth } from '@js/common/auth/modalHandler';
import { initModalAnalytics } from '@js/paywall_tts';
import { HttpMethods } from 'tagwalk-api-client/assets/js/common/enums';
import { imageSearchContext, ImageSearchPaywallModal, } from '@ts/homepage/search/component/imageSearch/ImageSearchPaywallModal';
import { rememberImageSearchResume, } from '@ts/homepage/search/component/imageSearch/imageSearch';
var TEAM_CONTACT_EMAIL = 'subscriptions@tag-walk.com';
var RESEND_DELAY_SECONDS = 300;
var NOT_LOGGED_SEGMENT = 'free-user-not-logged';
var LIMIT_REACHED_SEGMENT = 'free-user-who-reached-image-search-limit';
var body = document.querySelector('body');
if (body) {
    Modal.setAppElement(body);
}
export function membershipUrl(catalog, content, anchor) {
    if (anchor === void 0) { anchor = ''; }
    var url = generateRoute('membership_index', {
        utm_source: imageSearchContext(catalog),
        utm_content: content,
        need_login: 'no',
    });
    return url + anchor;
}
function usePaywallModalAnalytics(isOpen, catalog, segment) {
    useEffect(function () {
        if (!isOpen) {
            return;
        }
        initModalAnalytics(imageSearchContext(catalog), segment);
    }, [isOpen]);
}
function FreeModalFrame(props) {
    return (React.createElement(Modal, { isOpen: props.isOpen, onRequestClose: props.onClose, className: "image-search-modal tds " + (props.wide ? 'image-search-modal--wide' : 'image-search-modal--narrow'), overlayClassName: "image-search-modal-overlay backdrop" },
        React.createElement("div", { className: "image-search-modal-header" },
            React.createElement("h2", { className: "image-search-modal-title" }, translate('image_search.modal_title')),
            React.createElement("button", { type: "button", className: "image-search-modal-close", onClick: props.onClose, "aria-label": translate('image_search.close') },
                React.createElement("i", { className: "iconoir-xmark" }))),
        React.createElement("div", { className: "image-search-modal-body image-search-paywall image-search-paywall--free" },
            React.createElement("span", { className: "image-search-paywall-badge pill" }, translate('image_search.beta')),
            props.children)));
}
function LoginModal(props) {
    var freeLimit = props.access.freeLimit;
    var searches = translateChoice('image_search.free.image_searches', freeLimit, { count: freeLimit });
    usePaywallModalAnalytics(props.isOpen, props.catalog, NOT_LOGGED_SEGMENT);
    function openAuth(signIn) {
        if (!signIn) {
            rememberImageSearchResume();
        }
        props.onClose();
        initAuth('image_search', signIn);
    }
    return (React.createElement(FreeModalFrame, { isOpen: props.isOpen, onClose: props.onClose, wide: true },
        React.createElement("i", { className: "iconoir-google-lens image-search-paywall-icon", "aria-hidden": "true" }),
        React.createElement("h3", { className: "image-search-paywall-title" }, translate('image_search.free.login.title')),
        React.createElement("p", { className: "image-search-paywall-text" }, translate('image_search.free.login.text')),
        React.createElement("div", { className: "image-search-free-columns" },
            React.createElement("div", { className: "image-search-free-card" },
                React.createElement("p", { className: "image-search-paywall-eyebrow" }, translate('image_search.free.login.have_account')),
                React.createElement("ul", { className: "image-search-free-list" },
                    React.createElement("li", null,
                        React.createElement("i", { className: "iconoir-check", "aria-hidden": "true" }),
                        React.createElement("span", null,
                            React.createElement("b", null, translate('image_search.free.login.members_label')),
                            ": ",
                            translate('image_search.free.login.members_value'))),
                    React.createElement("li", null,
                        React.createElement("i", { className: "iconoir-check", "aria-hidden": "true" }),
                        React.createElement("span", null,
                            React.createElement("b", null, translate('image_search.free.login.free_label')),
                            ": ",
                            searches))),
                React.createElement("button", { type: "button", className: "btn btn-secondary", onClick: function () { return openAuth(true); } }, translate('image_search.free.login.login'))),
            React.createElement("div", { className: "image-search-free-card" },
                React.createElement("p", { className: "image-search-paywall-eyebrow" }, translate('image_search.free.login.new_user')),
                React.createElement("ul", { className: "image-search-free-list" },
                    React.createElement("li", null,
                        React.createElement("i", { className: "iconoir-check", "aria-hidden": "true" }),
                        React.createElement("span", null,
                            translate('image_search.free.login.create_prefix'),
                            " ",
                            React.createElement("b", null, searches))),
                    React.createElement("li", null,
                        React.createElement("i", { className: "iconoir-check", "aria-hidden": "true" }),
                        React.createElement("span", null,
                            translate('image_search.free.login.unlimited_prefix'),
                            ' ',
                            React.createElement("a", { href: membershipUrl(props.catalog, NOT_LOGGED_SEGMENT) }, translate('image_search.free.welcome.note_link'))))),
                React.createElement("button", { type: "button", className: "btn", onClick: function () { return openAuth(false); } }, translate('image_search.free.login.create')))),
        React.createElement("p", { className: "image-search-paywall-login" },
            translate('image_search.free.login.discover_prefix'),
            ' ',
            React.createElement("a", { href: membershipUrl(props.catalog, NOT_LOGGED_SEGMENT) }, translate('image_search.free.login.discover_link')))));
}
function UsedUpModal(props) {
    var freeLimit = props.access.freeLimit;
    usePaywallModalAnalytics(props.isOpen, props.catalog, LIMIT_REACHED_SEGMENT);
    return (React.createElement(FreeModalFrame, { isOpen: props.isOpen, onClose: props.onClose },
        React.createElement("p", { className: "image-search-paywall-eyebrow" }, translate('image_search.free.used_up.eyebrow')),
        React.createElement("h3", { className: "image-search-paywall-title" }, translateChoice('image_search.free.used_up.title', freeLimit, { count: freeLimit })),
        React.createElement("p", { className: "image-search-paywall-text" }, translate('image_search.free.used_up.text')),
        React.createElement("div", { className: "image-search-free-actions" },
            React.createElement("a", { className: "btn", href: membershipUrl(props.catalog, LIMIT_REACHED_SEGMENT, '#pricingTableAnchor') }, translate('image_search.free.used_up.subscribe'))),
        React.createElement("p", { className: "image-search-paywall-login" },
            translate('image_search.free.used_up.team_prefix'),
            ' ',
            React.createElement("a", { href: "mailto:" + TEAM_CONTACT_EMAIL }, translate('image_search.free.used_up.team_link')))));
}
function EmailModal(props) {
    var email = props.access.email;
    var _a = useState(null), message = _a[0], setMessage = _a[1];
    var _b = useState(false), sending = _b[0], setSending = _b[1];
    var _c = useState(0), resendAt = _c[0], setResendAt = _c[1];
    var _d = useState(Date.now()), now = _d[0], setNow = _d[1];
    var mountedRef = useRef(true);
    var secondsLeft = Math.max(Math.ceil((resendAt - now) / 1000), 0);
    useEffect(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    }, []);
    useEffect(function () {
        if (!props.isOpen) {
            return;
        }
        rememberImageSearchResume();
        setMessage(null);
    }, [props.isOpen]);
    useEffect(function () {
        if (!props.isOpen) {
            return;
        }
        startCountdown(props.access.resendAvailableIn);
    }, [props.isOpen, props.access.resendAvailableIn]);
    useEffect(function () {
        if (!props.isOpen || secondsLeft === 0) {
            return;
        }
        var timer = window.setInterval(function () { return setNow(Date.now()); }, 1000);
        return function () { return window.clearInterval(timer); };
    }, [props.isOpen, secondsLeft === 0]);
    function startCountdown(seconds) {
        setNow(Date.now());
        setResendAt(Date.now() + seconds * 1000);
    }
    function resend() {
        return __awaiter(this, void 0, void 0, function () {
            var result, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setSending(true);
                        result = 'image_search.free.email.error';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, fetchApi('api_register_validate_email', HttpMethods.post, {}, { email: email })];
                    case 2:
                        response = _a.sent();
                        if (response.ok) {
                            result = 'image_search.free.email.sent';
                        }
                        else if (response.status === 422) {
                            result = 'image_search.free.email.throttled';
                        }
                        if (response.ok || response.status === 422) {
                            startCountdown(RESEND_DELAY_SECONDS);
                        }
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        result = 'image_search.free.email.error';
                        return [3, 4];
                    case 4:
                        if (!mountedRef.current) {
                            return [2];
                        }
                        setMessage(translate(result));
                        setSending(false);
                        return [2];
                }
            });
        });
    }
    return (React.createElement(FreeModalFrame, { isOpen: props.isOpen, onClose: props.onClose },
        React.createElement("i", { className: "iconoir-mail image-search-paywall-icon", "aria-hidden": "true" }),
        React.createElement("p", { className: "image-search-paywall-eyebrow" }, translate('image_search.free.email.eyebrow')),
        React.createElement("h3", { className: "image-search-paywall-title" }, translate('image_search.free.email.title')),
        React.createElement("p", { className: "image-search-paywall-text" }, translate('image_search.free.email.text', { email: email })),
        React.createElement("button", { type: "button", className: "btn", onClick: resend, disabled: sending || email === '' || secondsLeft > 0 }, secondsLeft > 0
            ? translate('image_search.free.email.resend_in', { time: formatCountdown(secondsLeft) })
            : translate('image_search.free.email.resend')),
        message && React.createElement("p", { className: "image-search-paywall-login" }, message)));
}
export function ImageSearchDeniedModal(props) {
    var denial = props.denial === undefined ? props.access.denial : props.denial;
    if (denial === 'login_required') {
        return React.createElement(LoginModal, __assign({}, props));
    }
    if (denial === 'email_not_validated') {
        return React.createElement(EmailModal, __assign({}, props));
    }
    if (denial === 'free_limit_reached') {
        return React.createElement(UsedUpModal, __assign({}, props));
    }
    return (React.createElement(ImageSearchPaywallModal, { isOpen: props.isOpen, onClose: props.onClose, logged: props.access.logged, catalog: props.catalog }));
}
function formatCountdown(seconds) {
    var rest = seconds % 60;
    return Math.floor(seconds / 60) + ":" + (rest < 10 ? '0' : '') + rest;
}
